import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import AccountsList from "../Components/AccountsList";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./Accounts.css";

function Accounts() {
  const [isLoading, setIsLoading] = useState(true);
  const [accounts, setAccounts] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/accounts`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setAccounts(response.data.accounts);
      setIsLoading(false);
    }
    fetch();
  }, []);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="accounts-header">
            <h2>{t("Cuentas.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right accounts-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/accounts/new`}>
                  <FontAwesomeIcon icon={faPlus} /> {t("Cuentas.NuevaCuenta")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {accounts.length === 0 ? (
            <Col className="empty-accounts center">
              <h5>{t("Cuentas.SinCuentas")}</h5>
            </Col>
          ) : (
            <AccountsList accounts={accounts} />
          )}
        </Row>
      </Container>
    );
  }
}

export default Accounts;
